import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { AbsenceType } from "~/modules/absence/api/absenceType/absenceTypeTypes.ts";

export function indexAbsenceTypes(): AxiosApiResponsePromise<AbsenceType[]> {
	return axiosApi.get(`absence-types`);
}